"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_less_1 = __importDefault(require("./styles.less"));
var TextInput = (0, react_1.forwardRef)(function (props, ref) {
    var onKeyDown = (0, react_1.useCallback)(function (event) {
        props.onKeyDown && props.onKeyDown(event);
        if (event.key === 'Enter') {
            props.onSubmit && props.onSubmit(event);
        }
    }, [props.onKeyDown, props.onSubmit]);
    var _a = props.autoComplete, autoComplete = _a === void 0 ? 'one-time-code' : _a, _b = props.autoCorrect, autoCorrect = _b === void 0 ? 'off' : _b, _c = props.autoCapitalize, autoCapitalize = _c === void 0 ? 'off' : _c, _d = props.spellCheck, spellCheck = _d === void 0 ? false : _d, restProps = __rest(props, ["autoComplete", "autoCorrect", "autoCapitalize", "spellCheck"]);
    return (react_1.default.createElement("input", __assign({ size: 1, autoCorrect: autoCorrect, autoCapitalize: autoCapitalize, autoComplete: autoComplete, spellCheck: spellCheck, tabIndex: 0, "aria-autocomplete": "none", "data-form-type": "other", "data-lpignore": "true" }, restProps, { ref: ref, className: (0, classnames_1.default)(props.className, styles_less_1.default['text-input'], { 'disabled': props.disabled }), onKeyDown: onKeyDown })));
});
TextInput.displayName = 'TextInput';
exports.default = TextInput;
